import { buildEqFilter, mergeFilters, type GridFilters } from '@/ui/composites/grid/gridFilters';

export const mergeProjectFilters = (
  filters: GridFilters,
  projectId?: string | null,
): GridFilters => {
  const hasProjectFilter = filters.some((filter) => filter.field === 'projectId');
  const normalizedProjectId =
    typeof projectId === 'string' && projectId.trim().length > 0 ? projectId : null;
  const projectFilters =
    !hasProjectFilter && normalizedProjectId !== null
      ? buildEqFilter('projectId', normalizedProjectId)
      : [];
  return mergeFilters(projectFilters, filters);
};
